module.exports = __webpack_public_path__ + "img/hitachi-digital-host-3.80d6075b.jpg";